import React from 'react'
import { Card, CardContent } from 'src/component/ui/card'
import { Skeleton } from 'src/component/ui/skeleton'

export const MembershipSkeleton = (): React.ReactElement => {
  return (
    <>
      <Card className="bg-tertiary-grey mb-10">
        <CardContent className="p-3">
          <div className="space-y-3">
            <Skeleton className="h-8 w-[240px] mb-4" />
            <Skeleton className="h-5 w-[200px]" />
            <Skeleton className="h-5 w-[150px]" />
            <Skeleton className="h-5 w-[150px]" />
          </div>
        </CardContent>
      </Card>
      <Skeleton className="h-12 w-[246px] rounded-full" />
    </>
  )
}
